<div class="builder-header">
  <h2 class="builder-title">{{'AI_ASSISTANT.SETTINGS.AUTOMATION_GENERATOR.TITLE' | translate}}</h2>
  <button mat-icon-button type="button" aria-label="Back" (click)="cancel()">
    <mat-icon>arrow_back</mat-icon>
  </button>
</div>

<ai-generation-chat
  [placeholder]="'AI_ASSISTANT.SETTINGS.AUTOMATION_GENERATOR.PLACEHOLDER' | translate"
  [senderName]="'AI_ASSISTANT.SETTINGS.AUTOMATION_GENERATOR.TITLE' | translate"
  senderIcon="smart_toy"
  chatId="automation-assistant-builder"
  [hints]="[
    'AI_ASSISTANT.SETTINGS.AUTOMATION_GENERATOR.HINTS.START_FROM_SCRATCH' | translate,
    'AI_ASSISTANT.SETTINGS.AUTOMATION_GENERATOR.HINTS.ADD_STEP' | translate,
    'AI_ASSISTANT.SETTINGS.AUTOMATION_GENERATOR.HINTS.IMPROVE' | translate
  ]"
></ai-generation-chat>
